import React, { useGlobal } from "reactn";

export const useAuth = () => {
	const [user] = useGlobal("user");
	const isLoggedIn = !!user.token && !!user.email;
	const isLoggedInTemporary = !!user.token && !!user.temporal;

	return { isLoggedIn, isLoggedInTemporary };
};
